import { render, staticRenderFns } from "./uploadGames.vue?vue&type=template&id=c5f16634"
import script from "./uploadGames.vue?vue&type=script&lang=js"
export * from "./uploadGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports